export enum EntityStandardPropertyName {
    address = 'address',
}
